/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllSchedulePPD } from '../models/AllSchedulePPD';
import type { DepartmentSchedulePPD } from '../models/DepartmentSchedulePPD';
import type { SchedulePPD } from '../models/SchedulePPD';
import { request as __request } from '../core/request';

export class SchedulePpdService {

    /**
     * Get all schedule PPD records
     * @returns AllSchedulePPD List of schedule PPD records
     * @throws ApiError
     */
    public static async getAllPpd({
companyId,
date,
}: {
companyId: number,
/** get the details of the selected date PPD.
 *  **/
date?: string,
}): Promise<Array<AllSchedulePPD>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule-ppd`,
            query: {
                'date': date,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

    /**
     * Add a new schedule PPD record
     * @returns SchedulePPD Created schedule PPD record
     * @throws ApiError
     */
    public static async addSchedulePpd({
companyId,
requestBody,
}: {
companyId: number,
requestBody: Array<SchedulePPD>,
}): Promise<Array<SchedulePPD>> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule-ppd`,
            body: requestBody,
            errors: {
                400: `department id is required / date is required`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

    /**
     * Update an existing schedule PPD record
     * @returns SchedulePPD Updated schedule PPD record
     * @throws ApiError
     */
    public static async updateSchedulePpd({
companyId,
requestBody,
}: {
companyId: number,
requestBody: Array<SchedulePPD>,
}): Promise<Array<SchedulePPD>> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule-ppd`,
            body: requestBody,
            errors: {
                400: `bid id is required / department id is required / date is required`,
                404: `Record not found`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

    /**
     * Get all schedule PPD records
     * @returns DepartmentSchedulePPD List of schedule PPD records based on department
     * @throws ApiError
     */
    public static async getDepartmentPpd({
companyId,
date,
}: {
companyId: number,
/** get the details of the selected date PPD.
 *  **/
date?: string,
}): Promise<Array<DepartmentSchedulePPD>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule-ppd/department`,
            query: {
                'date': date,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

}